import { computed, Directive, input } from '@angular/core';
import { getSignalValue } from './angular-common-form';
import { AngularField } from './angular-form-fields';

@Directive()
export abstract class AngularBaseFieldWidget<TField extends AngularField<unknown, unknown>> {

	readonly randomId = `field-${crypto.randomUUID()}`;

	readonly field = input.required<TField>();

	readonly displayLabel = computed(() => getSignalValue(this.field().label));
}